import React from 'react';
import './style.less';

const GuestPickerIcon = () => (
    <svg className="guest-picker__icon" width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" >
        <g id="Family-Segment" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g id="Icon/Person/24---Gray" transform="translate(-2.000000, -2.000000)" fillRule="nonzero" stroke="#323F4D" strokeWidth="1.5">
                <path d="M12,12 C9.8,12 8,10.2 8,8 L8,7 C8,4.8 9.8,3 12,3 C14.2,3 16,4.8 16,7 L16,8 C16,10.2 14.2,12 12,12 Z" id="Shape" />
                <path d="M21,21 C21,17.64 18.1714286,15 14.5714286,15 L9.42857143,15 C5.82857143,15 3,17.64 3,21" id="Shape" />
            </g>
        </g>
    </svg>
);

export default GuestPickerIcon;
